export default __webpack_public_path__ + "static/media/head_idle_vp9.2f4cb943.webm";